import React, { Component } from "react";
import {
  Route,
  NavLink,
  BrowserRouter
} from "react-router-dom";
import Home from "./dashboard/Home";
import Accounts from "./dashboard/Accounts";
import Insurers from "./dashboard/Insurers";
import Benchmarking from "./dashboard/Benchmarking";
import Brokers from "./dashboard/Brokers";
import UserDetails from "./components/UserDetails"
import TowerAddUpdate from "./dashboard/TowerAddUpdate";
import UserSettings from "./dashboard/UserSettings";
import Users from "./dashboard/Users";
import SetUserCookies from "./dashboard/SetUserCookies";
import LogoHome from "./img/ico/color_home.png"
import LogoBroker from "./img/ico/color_broker.png"
import LogoReports from "./img/ico/color_reports.png"
import LogoInsurers from "./img/ico/color_insurers.png"
import LogoCompanies from "./img/ico/color_companies.png"
import LogoUsers from "./img/ico/color_users.png"
import LogoSettings from "./img/ico/color_settings.png"

import { getOrganization } from "./services/BinderDropService";

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      org:{
        towerCount:0,
        policyCount:0,
        totalPremium:0,
      }
    };
  }

  componentDidMount() {
    getOrganization().then((org) => {
      if(org){
        this.setState({org});
        console.log(org);
      }
    });
  }

  render() {
    /*
    <NavLink className="snmNavOption snmNavOptionAdmin" exact to="/settings">
            <img src={LogoSettings}/>
            <span>Settings</span>
          </NavLink>
          */
    return (
      <BrowserRouter>
        <nav className="" id="sidenav-main">
          <a id="snmLogo" href="/"/>

          <a id="addBinderButton" href="/tower">Add Tower</a>
          <NavLink className="snmNavOption" exact to="/">
            <img src={LogoHome}/>
            <span>Home</span>
          </NavLink>
          <NavLink className="snmNavOption" exact to="/accounts">
            <img src={LogoCompanies}/>
            <span>Accounts</span>
          </NavLink>
          {this.state.org.type !== "BrokerXX" &&
          <NavLink className="snmNavOption" exact to="/brokers">
            <img src={LogoBroker}/>
            <span>Brokers</span>
          </NavLink>
          }
          
          <NavLink className="snmNavOption" exact to="/insurers">
            <img src={LogoInsurers}/>
            <span>Insurers</span>
          </NavLink>
          <NavLink className="snmNavOption" exact to="/benchmarking">
            <img src={LogoReports}/>
            <span>Benchmarking</span>
          </NavLink>
          
          

          <div className="snmSeparator"></div>


          <NavLink className="snmNavOption snmNavOptionAdmin" exact to="/users">
            <img src={LogoUsers}/>
            <span>Users</span>
          </NavLink>
          

            <UserDetails/>
        </nav>
  
        <div id="dashboardContent">
          
            <Route exact path="/" component={() => <Home org={this.state.org}/>}/>
            <Route path="/accounts" component={Accounts}/>
            <Route path="/brokers" component={Brokers}/>
            <Route path="/insurers" component={Insurers}/>
            <Route path="/benchmarking" component={Benchmarking}/>
            
            <Route path="/tower" component={TowerAddUpdate}/>
            <Route path="/user" component={UserSettings}/>
            <Route path="/users" component={Users}/>
            <Route path="/loggedin" component={SetUserCookies}/>
            <div id="footer"></div>
        </div>
      </BrowserRouter>
    );
  }
}
 
export default Dashboard;